/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

const searchParamsObject = () => {
  if (typeof window !== 'undefined') {
    return new URLSearchParams(window.location.search);
  }
  return new URLSearchParams();
};

export const getKeyValue = (key) => {
  return searchParamsObject().get(key);
};

function useQueryParams(key, defaultVal) {
  const [query, setQuery] = useState(getKeyValue(key) || defaultVal);

  const updateUrl = (newVal) => {
    setQuery(newVal);

    const searchParams = searchParamsObject();

    if (newVal.trim() !== '') {
      searchParams.set(key, newVal);
    } else {
      searchParams.delete(key);
    }

    if (typeof window !== 'undefined') {
      const { protocol, pathname, host } = window.location;
      const newUrl = `${protocol}//${host}${pathname}?${searchParams.toString()}`;
      window.history.replaceState({}, '', newUrl);
    }
  };

  useEffect(() => {
    updateUrl(getKeyValue(key) || defaultVal);
  }, []);

  return [query, updateUrl];
}

export default useQueryParams;
